export enum SoftswissLaunchStrategy {
  Redirect = 'redirect',
  Iframe = 'iframe',
  Detect = 'detect',
}
